import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

// material-ui
import { Box, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import { MenuContext } from 'contexts';
import { MenuProps } from 'types/menu';
import { securelyCacheData, securelyRetrieveData } from 'utils';
import Header from './Header';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {

  const [menuState, setMenuState] = useState<MenuProps>({
    openItem: [],
    selectedID: null
  })
  // drawer toggler
  const retrievedDrawerOpen = securelyRetrieveData("drawerOpen");
  const drawerOpen = retrievedDrawerOpen !== undefined ? retrievedDrawerOpen : true
  const [open, setOpen] = useState(drawerOpen);

  const handleDrawerToggle = () => {
    setOpen(!open);
    securelyCacheData("drawerOpen", !open);
  };

  useEffect(() => {
    if (open !== drawerOpen) securelyCacheData("drawerOpen", drawerOpen);;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  return (
    <Box sx={{ display: 'flex', width: '100%', minHeight: "100vh", background: "white" }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <MenuContext.Provider value={{ menuState, setMenuState }} >
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      </MenuContext.Provider>
      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
